import { defineComponent } from 'vue';
import CategoryTwelveFileUploadComponent from '@/components/CategoryTwelve/CategoryTwelveFileUploadComponent.vue';
export default defineComponent({
    name: 'CategoryTwelveFileUploadDialog',
    props: {
        propSelected: Array
    },
    components: { CategoryTwelveFileUploadComponent },
    data: function () {
        return {
            show: false
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
